import React, { useState } from "react";
import BellIcon from "../../../assets/images/bell.svg";
import UserIcon from "../../../assets/images/ardenuser.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AiFillCloseCircle } from "react-icons/ai";


const NotificationWidget = ({ isOpen, onClose }) => {
  const [notifications] = useState([
    {
      id: 1,
      title: "Data Extraction Completed",
      description: "Scheduled job completed successfully.",
      time: "2 hours ago",
      icon: <img src={UserIcon} alt='Arden' />
    },
    {
      id: 2,
      title: "Transmission Initiated",
      description: "Data transfer process started.",
      time: "3 hours ago",
      icon: <img src={UserIcon} alt='Arden' />
    },
    {
      id: 3,
      title: "Successful Delivery Confirmation",
      description: "Data was successfully transmitted to Surefyre.",
      time: "5 hours ago",
      icon: <img src={UserIcon} alt='Arden' />
    },
    {
      id: 4,
      title: "Transmission Failure Alert",
      description: "Data transmission to Surefyre failed.",
      time: "1 day ago",
      icon: <img src={UserIcon} alt='Arden' />
    }
  ]);

  const handleClearAll = () => {
    console.log("Clear all notifications");
  };

  const handleViewAll = () => {
    console.log("View all notifications");
    onClose();
  };

  const handleNotificationClick = (notificationId) => {
    console.log(`Clicked notification: ${notificationId}`);
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="notification-overlay"
        onClick={onClose}
      />
      
      {/* Notification Widget */}
      <div 
        className="notification-container shadow-md"
      >
        {/* Header */}
        <div className="notification-header">
          <h6>Notifications</h6>
          <button
            onClick={handleClearAll}
          >
            Clear all
          </button>
        </div>

        {/* Notification List */}
        <div className="notification-list">
          {notifications.map((notification) => (
            <div 
              key={notification.id}
              className="notification-item active"
              style={{ cursor: 'pointer' }}
              onClick={() => handleNotificationClick(notification.id)}
            >
              <div 
                className="user-icon"
              >
                {notification.icon}
              </div>
              <div className="notificaton-text">
                <div className="notification-title">
                  <h6>
                    {notification.title}
                  </h6>
                  <button>
                    <AiFillCloseCircle />
                  </button>
                </div>
                <p>
                  {notification.description}
                </p>
                <small>{notification.time}</small>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="notification-footer">
          <button 
            className="btn w-100 text-white"
            onClick={handleViewAll}
            style={{ 
              backgroundColor: '#122066', 
              border: 'none',
              fontSize: '0.9rem'
            }}
          >
            View all
          </button>
        </div>
      </div>

      <style jsx>{`
        .notification-item:hover {
          background-color: #f8f9fa;
        }
        .notification-item:last-child {
          border-bottom: none !important;
        }
      `}</style>
    </>
  );
};

export { NotificationWidget };

// For your existing bell icon, wrap it like this:
const BellIconWithNotifications = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const toggleNotification = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  return (
    <div className="position-relative">
      {/* <i
        className="bi bi-bell text-success"
        style={{ fontSize: "1.5rem", cursor: "pointer" }}
        onClick={toggleNotification}
      ></i> */}
      <a
        style={{ fontSize: "1.5rem", cursor: "pointer" }}
        onClick={toggleNotification}
      >
        <img src={BellIcon} alt="Bell" />
      </a>
      
      <NotificationWidget 
        isOpen={isNotificationOpen}
        onClose={() => setIsNotificationOpen(false)}
      />
    </div>
  );
};

export default BellIconWithNotifications;